// src/components/FormDetails.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap styles
import { useNavigate, Link } from 'react-router-dom';
import {Navbar, Nav , Container, Button, Modal, Table, Card} from 'react-bootstrap';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import JsBarcode from "jsbarcode";
//import { API_URL } from "../apiURL";

const AdmitDetails = () => {
  const [formDetails, setFormDetails] = useState(null);
  const { applicationNumber } = useParams();
  const [photoURL, setphotoURL] = useState("");
  const [signURL, setsignURL] = useState("");

  const navigate = useNavigate();

  const handleFormsClick = () => {
    navigate("/home");
  };


  function generatePDF() {
    const pdf = new jsPDF('p', 'mm', 'a4');



    // Watermark text
    const watermarkText = "LPSSRB";

    // Add watermark to each page
    const addWatermark = () => {
        pdf.setFontSize(50); // Set font size for the watermark
        pdf.setTextColor(150, 150, 150); // Set a light gray color for the watermark
        pdf.setDrawColor(150, 150, 150); // Set border color if needed
        pdf.setGState(new pdf.GState({ opacity: 0.2 })); // Set opacity for the watermark
        pdf.text(
            watermarkText,
            pdf.internal.pageSize.getWidth() / 2,
            pdf.internal.pageSize.getHeight() / 2,
            { align: 'center', angle: 45 } // Center and rotate the text
        );
    };

    const addWatermarkBorder = () => {
      const text = "LPSSRB "; // Repeating watermark text
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const textSpacing = 15.5; // Space between lines for vertical text

      pdf.setFontSize(10); // Set font size for the watermark text
      pdf.setTextColor(150, 150, 150); // Set a light gray color for the watermark text
      pdf.setGState(new pdf.GState({ opacity: 0.5 })); // Set opacity for the watermark

      // Top border
      let xPos = 7; // Start position for top border text
      while (xPos < pageWidth - 20) {
          pdf.text(text, xPos, 2, { baseline: 'middle' });
          xPos += pdf.getTextWidth(text); // Increment by the width of the text
      }

      // Bottom border
      xPos = 7;
      while (xPos < pageWidth - 20) {
          pdf.text(text, xPos, pageHeight - 12, { baseline: 'middle' });
          xPos += pdf.getTextWidth(text);
      }

      // Left border
      let yPos = 20; // Start position for left border text
      while (yPos < pageHeight - 6) {
          pdf.text("LPSSRB", 10, yPos, { angle: 90 }); // Rotate text for vertical alignment
          yPos += textSpacing; // Add spacing between text
      }

      // Right border
      yPos = 20;
      while (yPos < pageHeight - 6) {
          pdf.text("LPSSRB", pageWidth - 10, yPos, { angle: 90 }); // Rotate text for vertical alignment
          yPos += textSpacing; // Add spacing between text
      }
  };


  
    // Define the content of the table
    const tableContent = [];
    formDetails && Object.keys(formDetails).forEach(key => {
      var keyName= key
      if(key ==="applicationNumber"){
        keyName = "Application Number"
      }else if (key === "group"){
        keyName = "Group"
        //formDetails[key] = formDetails[key].slice(1,-1)
      }else if (key ==="email"){
        keyName = "Email"
      }else if (key === "post"){
        formDetails[key] = formDetails[key].slice(2,-2)
      }else if (key === "f_name"){
        keyName = "Father's Name"
      }
      else if (key === "fullAddress"){
        keyName = "Full Address"
      }else if (key === "gender"){
        keyName = "GENDER"
      }else if (key ==="status"){
        keyName = "Payment Status"
      }else if (key === "dob"){
        keyName = "Date of Birth"
      }else if (key === "zipcode"){
        keyName = "Pincode"
      }else if (key === "petcenter"){
        keyName = "VENUE"
      }else if(key === "writtenCenter"){
        keyName = "Preferred Center for Written Exam"
      }else if(key === "testcity"){
        keyName = "City"
      }

      else if(key === "esm"){
        keyName = "Ex-Servicemen"
        /*
        if(formDetails[key] === "noEsm"){
          formDetails[key] = "NO"
        }else{
          formDetails[key] = "YES"
        }
          */
        
      }
      else if(key === "bonus"){
        keyName = "Desired Qualification"
        if(formDetails[key] === "noAQT"){
          formDetails[key] = "NO"
        }
        
      }
      else if(key === "ncc"){
        keyName = "NCC"
        if(formDetails[key] === "noNcc"){
          formDetails[key] = "NO"
        }
        
      }

      if(key==="centre_name"){
        keyName = "EXAM CENTER"
      }
      if(key==="Posts" || key==="status" || key==="petdate" || key==="rollno" || key==="shift" || key==="email" || key==="shiftcode"||key==="reporting_time" || (key==="date_of_exam" || key==="time_of_exam")){
        console.log(key)
      }else{
        tableContent.push([keyName, formDetails[key]]);
      }
      
    });



    // Generate the barcode as an image
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, formDetails.rollno, {
      format: "CODE128",
      displayValue: false,
      fontOptions: "OCR-B"
    });

    // Convert the canvas to a data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");

    // Add the barcode image to the PDF
    pdf.addImage(barcodeDataURL, "PNG", 100, 51, 60, 40);

    // Convert tableContent to a two-column layout
    const twoColumnTableContent = [];
    for (let i = 0; i < tableContent.length; i += 2) {
        const row = [];
        row.push(tableContent[i][0], tableContent[i][1]); // Add the first column data

        // If the next element exists, add it to the second column, else leave it blank
        if (i + 1 < tableContent.length) {
            row.push(tableContent[i + 1][0], tableContent[i + 1][1]);
        } else {
            row.push('', ''); // Empty placeholders if odd number of items
        }
        twoColumnTableContent.push(row);
    }
  

    //add logo
    //pdf.addImage("/logo_0.png", 'PNG', 50, 5, 110, 15);
    pdf.addImage("/logo_32.png", 'PNG', 14, 5, 182, 14);

    //set line width
    pdf.setLineWidth(0.1);
    // Draw a border around the logo
    pdf.rect(14, 4, 182, 16);
    //pdf.rect(14, 40, 182, 39);

    pdf.setLineWidth(0.5);

    
    // Add the heading text at the calculated position
    const headingText = "LADAKH POLICE SUBORDINATE SERVICE RECRUITMENT BOARD (LPSSRB)\nTHE ADMINISTRATION OF UNION TERRITORY OF LADAKH"
    // Define the styling for the heading text
    const styles = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 10, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };

    // Add the heading text using autoTable
    pdf.autoTable({
      startY: 20, // Set the starting y-coordinate for the table
      body: [[headingText]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles, // Apply the custom styles to the heading text
    });
     pdf.autoTable({
      startY: pdf.autoTable.previous.finalY, // Set the starting y-coordinate for the table
      body: [["Advertisement Notification No. 01 of 2026"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles, // Apply the custom styles to the heading text
    });

    pdf.autoTable({
      startY: pdf.autoTable.previous.finalY, // Set the starting y-coordinate for the table
      body: [["Physical Test Admit Card"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles, // Apply the custom styles to the heading text
    });

    pdf.autoTable({
        startX: 110,  // X-coordinate (horizontal position) from the left side of the page
        startY: 49,  // Y-coordinate (vertical position) from the top of the page
        tableWidth: 50,
        //head: [['Column 1', 'Column 2']],  // Column headers
        body: [
            ["ROLLNO", formDetails.rollno],
            ["TEST DATE", formDetails.date_of_exam],
            ["SHIFT", formDetails.shift],
            ["REPORTING TIME", formDetails.reporting_time]
        ],
        theme: 'striped',
        styles: {fontStyle: 'bold', // Make the text bold
            fontSize: 11, // Set the font size
            cellWidth: 'wrap', // Wrap the text within the cell
            halign: 'center', // Center align the text horizontally
            valign: 'middle', // Center align the text vertically
            //fillColor: [76,124,124], // Disable fill color for the cell
            //textColor: [255, 255, 255], // Set text color to black
            lineColor: [0, 0, 0], // Set line color for the cell border
            lineWidth: 0.1, // Set line width for the cell border
            cellPadding: 2, // Set padding for the cell
            textDecoration: 'underline', // Add underline to the text
            }
      });


    pdf.setFontSize(10);
    //pdf.addImage("/jpg/"+formDetails.rollno+".jpg", 'JPEG', 160, 52, 35, 35);
    pdf.addImage(photoURL, 'JPEG', 160, 52, 35, 35);
    //pdf.addImage(signURL, 'JPEG', 140, 300, 40, 20);
    //pdf.text("I have read, understood and agree to the above.                          Candidate Signature: ____________________", 15, 290);
    // Add the table to the PDF

    const styles2 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 10, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: [6, 33, 63], // Disable fill color for the cell
      textColor: [255, 255, 255], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    pdf.autoTable({
      startY: 89, // Set the starting y-coordinate for the table
      body: [["Candidate Details"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    //const uppercaseTableContent = tableContent.map(row => row.map(cell => typeof cell === 'string' ? cell.toUpperCase() : cell));
    const uppercaseTableContent = twoColumnTableContent.map(row => row.map(cell => typeof cell === 'string' ? cell.toUpperCase() : cell));
    pdf.autoTable({startX: 15, startY: 97, head: [], body: uppercaseTableContent , theme: "striped", styles: { lineColor: [0,0,0], lineWidth: 0.1, fontSize: 7,
        columnStyles: {
            0: { cellWidth: 20 }, // Fix width of the first column (label 1)
            1: { cellWidth: 20, overflow: 'ellipsis'  }, // Fix width of the second column (value 1)
            2: { cellWidth: 20 }, // Fix width of the third column (label 2)
            3: { cellWidth: 20, overflow: 'ellipsis' }, // Fix width of the fourth column (value 2)
        }
    }});

    //const disclaimer = "1. This Admit Card does not by itself give any entitlement whatsoever for any appointment in the Meghalaya Police.\n\n2. Candidates will not be allowed to enter the Examination Hall/ Room without this Admit Card.\n\n3. Candidates should bring any one of the I.D card (EPIC/ AADHAR/ Driving Licence/ PAN Card) for I.D proof and bring their own clipboard, blue or black ball point pen for the written examination.\n\n4. No TA/DA will be admissible to appear for the written examination.\n\n5. Candidates should report two hours before commencement of the examination and are required to take their allocated seats before the commencement of examination. The exam shall commence after completing all formalities etc.\n\n6. No candidate shall be allowed to enter the Examination Hall /Room once the examination has commenced. No candidate will be permitted to leave the Examination Hall/Room before the examination is over and other formalities are completed.\n\n7. Candidates should check the examination schedule carefully and the duration of the examination as specified in this Admit Card.\n\n8. Change of venue/centre for the examination will not be permitted under any circumstances.\n\n9. Book, Note book, Calculator, Mobile phone or any other electronic gadgets will not be permitted in the Examination Hall/ Room.\n\n10. Using any unfair means in connection with the examination/misbehavior causing disturbance in the examination hall will disqualify a candidate.\n\n11. Candidates found indulging in malpractices/impersonations will be dealt with Police/ Legal action.";
    
    const disclaimer = "1. Report at least 30 minutes before the reporting time indicated above. Late reporting shall not be permitted under any circumstances.\n2. Candidates shall be admitted only at the centre, date and shift allotted to them. No request for change of date, time or centre shall be entertained.\n3. Candidates who do not qualify the Physical Standard Test (PST) shall be disqualified and shall not be permitted to attempt the Physical Endurance Test (PET).\n4. The PST and PET are of qualifying nature only and must be qualified separately; only candidates who qualify the Long Race are eligible to attempt the Long Jump, followed by Push-ups (male candidates) or Shot Put (female candidates).\n5. No repeat or second chance or relaxation in the prescribed standard shall be given under any circumstances.\n6. Candidates appear for the PST/PET entirely at their own risk. The LPSSRB shall not be responsible or liable for any injury, damage, or loss of any kind that may occur during the Test. Candidates must satisfy themselves as to their physical and mental fitness before undertaking the Test, and must submit the signed declaration at Annexure-A before commencement.\n7. Use of mobile phones or any electronic device is strictly prohibited within the test venue.\n8. Candidates must make their own arrangements for travel, boarding and lodging. No TA/DA is admissible for attending the PST/PET.\n9. Biometric verification and CCTV surveillance shall be in operation at the venue; biometric data and CCTV records shall be used strictly for authentication, security and examination-integrity purposes.\n10. In the event of biometric mismatch or technical failure during the process, the matter shall be handled as per prescribed protocol; the decision of the Board shall be final and binding.\n11. Any grievance regarding the conduct of the PST/PET must be brought to the notice of the Chairman, LPSSRB on the same day, before completion of the Test; the Chairman's decision thereon shall be final and binding.\n12. Issuance of this Admit Card is only a permission to appear for the Test and does not, in itself, indicate that the Board is satisfied with the candidate's eligibility, documents or testimonials, nor does it confer any claim to appointment.\n13.Initial document verification of the candidates who qualify the Physical Standard Test (PST) and Physical Endurance Test (PET) shall be carried out by the Board on the next day at the Document Verification Centre located at the exit gate of the stadium.\n14. Please bring a copy of Aadhaar Card/e-Aadhaar printout/Voter ID/Driving Licence/PAN Card /Passport /College-University ID/Employer's ID (Govt./PSU/Private)";
    // Define the styling for the heading text
    const styles3 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 9, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'left', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    const styles4 = {
      fontStyle: 'bold', // Make the text bold
      fontSize: 8, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'center', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    

    /*
    pdf.autoTable({
    startX: 15,
    startY: 140, // Set the starting y-coordinate for the table
    head: [['Document Checking', 'Height', "I have been measured for height satisfactorily \nand have no objections to the reading written here.", "          "]],
    body: [
        ['',"                   ·         cm","",""],
        ['Signature of G.Os', 'Signature of G.Os', 'Signature of Candidate', 'Member Secretary, CRB']
    ],
    theme: 'grid', // Set the table theme to 'grid' for border styling
    headStyles: {
      fillColor: [76, 124, 124], // Header background color
      textColor: [255, 255, 255], // Header text color (white)
    },
    bodyStyles: {
      fillColor: [255, 255, 255], // Body background color (white)
      textColor: [0, 0, 0],       // Body text color (black)
    },
    styles: { lineColor: [0,0,0], lineWidth: 0.1, fontSize: 8,
        //fillColor: [76,124,124], // Disable fill color for the cell
        //textColor: [255, 255, 255], // Set text color to black
        halign: 'center', // Center align the text horizontally
        valign: 'bottom', // Center align the text vertically
        columnStyles: {
            0: { cellWidth: 20 }, // Fix width of the first column (label 1)
            1: { cellWidth: 20, overflow: 'ellipsis'  }, // Fix width of the second column (value 1)
            2: { cellWidth: 20 }, // Fix width of the third column (label 2)
            3: { cellWidth: 20, overflow: 'ellipsis' }, // Fix width of the fourth column (value 2)
        }
    },
    didParseCell: function (data) {
      if (data.row.index === 1) { // Target the second row (index is zero-based)
          data.cell.styles.minCellHeight = 15; // Set custom height (double the default)
      }
      if (data.row.index === 0) { // Adjust this index to match the row you want to style
          data.cell.styles.valign = 'middle';
      }
  }
    });
    
    */



    /*
    pdf.autoTable({
    startX: 15,
    startY: 145, // Set the starting y-coordinate for the table
    head: [['Document Checking', 'Height', "I have been measured for height satisfactorily \nand have no objections to the reading written here."]],
    body: [
        ['_________', "___________ cm", "________"],
        ['Signature of G.Os', 'Signature of G.Os', 'Signature of Candidate']
    ],
    theme: 'grid', // Set the table theme to 'grid' for border styling
    styles: {
        lineColor: [0, 0, 0], // Border color
        lineWidth: 0.1,
        fontSize: 8,
        halign: 'center', // Center align the text horizontally
        valign: 'middle', // Center align the text vertically
        columnStyles: {
            0: { cellWidth: 20 }, // Fix width of the first column (label 1)
            1: { cellWidth: 20 }, // Fix width of the second column (value 1)
            2: { cellWidth: 20 }, // Fix width of the third column (label 2)
            3: { cellWidth: 20 }, // Fix width of the fourth column (value 2)
        }
    },
    headStyles: {
        fillColor: [76, 124, 124], // Header background color
        textColor: [255, 255, 255], // Header text color (white)
    },
    bodyStyles: {
        fillColor: [255, 255, 255], // Body background color (white)
        textColor: [0, 0, 0],       // Body text color (black)
    },
    columnStyles: {
        0: { cellWidth: 20 }, // Fix width of the first column (label 1)
        1: { cellWidth: 20 }, // Fix width of the second column (value 1)
        2: { cellWidth: 20 }, // Fix width of the third column (label 2)
        3: { cellWidth: 20 }, // Fix width of the fourth column (value 2)
    }
});
  */

    

    // Add the heading text using autoTable
    pdf.autoTable({
      startX: 15,
      startY: 154, // Set the starting y-coordinate for the table
      body: [["IMPORTANT INSTRUCTIONS TO THE CANDIDATES"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    pdf.autoTable({
        startX: 15,
        startY: 164, // Set the starting y-coordinate for the table
        body: [[disclaimer]], // Pass the heading text as a single-row array
        theme: 'grid', // Set the table theme to 'grid' for border styling
        styles: styles3, // Apply the custom styles to the heading text
      });

      /*
    pdf.autoTable({
      startX: 15,
      startY: 250, // Set the starting y-coordinate for the table
      body: [["DECLARATION"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    const declaration = "I have read and understood all the instructions printed on this Admit Card and in the Indemnity. I am appearing for the Physical Standard Test (PST) and Physical Endurance Test (PET) voluntarily and at my own risk, and I agree to abide by the decisions of the LPSSRB, which shall be final and binding. \n\n Candidate Name: _________________________   Rollno: ________________   Signature: ______________________ ";
    pdf.autoTable({
        startX: 15,
        startY: 260, // Set the starting y-coordinate for the table
        body: [[declaration]], // Pass the heading text as a single-row array
        theme: 'grid', // Set the table theme to 'grid' for border styling
        styles: styles3, // Apply the custom styles to the heading text
      });
      */


      /*
    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;

    // Set footer content
    const footerContent = `Generated at: ${formattedDate} ${formattedTime}`;
      */

    // Get current date and time
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getMonth() + 1).toString().padStart(2, '0')}/${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:${currentDate.getSeconds().toString().padStart(2, '0')}`;

    // Set footer content
    const footerContent = `Generated at: ${formattedDate} ${formattedTime}`;
    // Set the fill color to white
    pdf.setFillColor(255, 255, 255);

    // Draw a rectangle (x, y, width, height) and fill it with the set color
    //pdf.rect(159, 140, 36.8, 15, 'F');
    pdf.addImage('/CRBsign.png', 'PNG', 160, 270, 40, 20);
    pdf.text("Member Secretary, LPSSRB.", 160, 290);



    //make height small squares
    //pdf.setFillColor(255, 255, 255);  // White fill
    //pdf.setDrawColor(0, 0, 0);        // Black border

    // Draw the first rectangle with white fill and black border
    //pdf.rect(49, 151, 5, 5, 'FD'); // 'FD' stands for fill and draw border

    // Draw the second rectangle with white fill and black border
    //pdf.rect(54, 151, 5, 5, 'FD');
    //pdf.rect(58.5, 151, 5, 5, 'FD');

    //pdf.rect(67.5, 151, 5, 5, 'FD');

    //pdf.text(footerContent, 15, 290);
    // Add watermark to the first page after content
    addWatermark();
    addWatermarkBorder();
    pdf.setGState(new pdf.GState({ opacity: 1 }));

    // ---------------------------
    // PAGE 2
    // ---------------------------
    pdf.addPage();
    pdf.addImage("/logo_32.png", "PNG", 14, 5, 182, 14);

    //pdf.rect(14, 4, 182, 16);
    
    pdf.autoTable({
      startX: 15,
      startY: 22, // Set the starting y-coordinate for the table
      body: [["DECLARATION"]], // Pass the heading text as a single-row array
      theme: 'grid', // Set the table theme to 'grid' for border styling
      styles: styles2, // Apply the custom styles to the heading text
    });
    const styles33 = {
      //fontStyle: 'bold', // Make the text bold
      fontSize: 10, // Set the font size
      cellWidth: 'wrap', // Wrap the text within the cell
      halign: 'left', // Center align the text horizontally
      valign: 'middle', // Center align the text vertically
      fillColor: false, // Disable fill color for the cell
      textColor: [0, 0, 0], // Set text color to black
      lineColor: [0, 0, 0], // Set line color for the cell border
      lineWidth: 0.1, // Set line width for the cell border
      cellPadding: 2, // Set padding for the cell
      textDecoration: 'underline', // Add underline to the text
    };
    const declaration = "I have read and understood all the instructions printed on this Admit Card and in the Indemnity. I am appearing for the Physical Standard Test (PST) and Physical Endurance Test (PET) voluntarily and at my own risk, and I agree to abide by the decisions of the LPSSRB, which shall be final and binding.";
    pdf.autoTable({
        startX: 15,
        startY: 32, // Set the starting y-coordinate for the table
        body: [[declaration]], // Pass the heading text as a single-row array
        theme: 'grid', // Set the table theme to 'grid' for border styling
        styles: styles33, // Apply the custom styles to the heading text
      });

    pdf.autoTable({
        startY: 50,
        body: [[
            `INDEMNITY CERTIFICATE FOR PARTICIPATION IN PST / PET`
        ]],
        theme: "grid",
        styles: styles2
        /*{
            fontStyle: 'bold', // Make the text bold
            fontSize: 14, // Set the font size
            cellWidth: 'wrap', // Wrap the text within the cell
            halign: 'center', // Center align the text horizontally
            valign: 'middle', // Center align the text vertically
            fillColor: false, // Disable fill color for the cell
            textColor: [0, 0, 0], // Set text color to black
            lineColor: [0, 0, 0], // Set line color for the cell border
            lineWidth: 0.1, // Set line width for the cell border
            cellPadding: 2, // Set padding for the cell
            textDecoration: 'underline', // Add underline to the text
            
        }
            */
    });
    let declarationText =
    `I,      ${formDetails.name},

        S/O, D/O  ${formDetails.f_name}

    
    
    Resident of ${formDetails.address} 

    P.S: __________________________

    RollNo: ${formDetails.rollno}

    
    
    hereby declare that I am completely capable and fit to appear in the Physical Standard Test and Physical Endurance Test for the post of Sub-Inspector General Cadre (Executive, Armed/IRP, SDRF, Women Bn. and Border Bn.) in Ladakh Police.

    
    During the above tests, if any physical injury or untoward incident takes place, the LPSSRB and the concerned officers conducting the tests shall not be held responsible.

    
    
    I will be solely responsible for the same.
    `;

    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);

    pdf.text(
        declarationText,
        20,
        68,
        {
            maxWidth: 170
        }
    );

    pdf.line(15, 250, 55, 250);
    pdf.text("Place", 15, 256);

    pdf.line(65, 250, 105, 250);
    pdf.text("Date", 80, 256);

    pdf.line(115, 250, 190, 250);
    pdf.text(`Signature of Candidate\n (${formDetails.name})`, 140, 256);

    pdf.text("NOTE: PRINT ON SEPARATE SHEET. MUST BE SUBMITTED AT THE TIME OF P.E.T", 20, 290);

  
    // Save the PDF
    pdf.save(formDetails.rollno+"-"+formDetails.phone+'-admitCard.pdf');
  }


  const handleGoBack = () => {
    navigate("/downloadAdmit")
  };

  useEffect(() => {

    console.log(applicationNumber)
    // Fetch form details using Axios (replace the URL with your actual endpoint)

    
    
    //get photo and signature
    axios.get(`/api/getImages`).then(response => {
      console.log(response.data)
      setphotoURL(response.data.photoUrl)
      setsignURL(response.data.signURL)
    })
    

    axios.post(`/api/getAdmitDetails`, { applicationNumber })
      .then(response => {
        if(response.data.status === 0){
          response.data.status = "Payment was incomplete. Please wait a while for clearance."
        }else if(response.data.status === 1){
          response.data.status = "Success"
        }else if(response.data.status === 2){
          response.data.status = "Fail"
        }
        setFormDetails(response.data);
      })
      .catch(error => {
        console.error('Error fetching admit card details:', error);
        navigate("/");
      });
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' , padding: '15px',backgroundColor:"#06213f"}}>
              <img src="/logo_0.png" alt="Header Image" style={{ height: '100px', backgroundColor:"#06213f"}} />
            </div>
            <Navbar variant="dark" style={{ backgroundColor: '#06213f'}}>
              <Container>
                <Navbar.Brand href="/home">Ladakh Police Recruitment 2026</Navbar.Brand>
                <Nav className="me-auto">
                  {/*
                  <Nav.Link onClick={handleFormsClick}>Application Forms</Nav.Link>
                  <Nav.Link onClick={console.log("admit click..")}>Download Admit Cards</Nav.Link>
                  <Nav.Link onClick={handleProfileClick}>Profile</Nav.Link>
                  */}
                  
                </Nav>
              </Container>
            </Navbar>
      
            <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#dee0d7', padding: '20px' , height: '100vh' }}>
      

        
        <Card className="shadow-sm" style={{ borderColor: "#000", maxWidth: "80rem", width: '100%'}}>
          <Card.Body>
          <h2 style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold'}}>Admit Card Details  {formDetails? "("+formDetails.rollno+")": " "}</h2>
          <br></br>
          {formDetails ? (
            <table id="formDetailsTable" className="table table-bordered">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{formDetails.name}</td>
                </tr>
                <tr>
                  <th>Father's Name</th>
                  <td>{formDetails.f_name}</td>
                </tr>
                <tr>
                  <th>Post</th>
                  <td>{formDetails.post.slice(2,-2)}</td>
                </tr>
                <tr>
                  <th>Gender</th>
                  <td>{formDetails.gender}</td>
                </tr>
                <tr>
                  <th>Date of Exam</th>
                  <td>{formDetails.date_of_exam}</td>
                </tr>
                <tr>
                  <th>Category</th>
                  <td>{formDetails.category}</td>
                </tr>
                <tr>
                  <th>Application Number</th>
                  <td>{formDetails.applicationNumber}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{formDetails.phone}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div className="alert alert-info" role="alert">
              Loading form details...
            </div>
          )}



        <center>
          <Button onClick={generatePDF} variant="primary" style={{ marginRight: '10px', backgroundColor: '#06213f'}}>Download Admit Card</Button>{' '}
          <Button onClick={handleGoBack} variant="danger">Go Back</Button>{' '}
        </center>

    
        </Card.Body>
        </Card>
    </div>
    

  </div>
  );
};

export default AdmitDetails;
